"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _Pill = _interopRequireDefault(require("./Pill"));

var _styling = require("../../toolkit/styling");

//
//  PillRow.tsx
//  Project-Lego
//
//  Created by Prian Kuhanandan on 12/06/19.
//  Copyright © 2019-present ContextLogic Inc. All rights reserved.
//

/* Lego Components */

/* Lego Toolkit */
var propDoc = {
  options: {
    required: true,
    type: "Array<{ value: any, title: string }>",
    description: "List of options"
  },
  selected: {
    required: true,
    type: "ReadonlySet<any>",
    description: "List of values that are currently selected."
  },
  onCheckedChanged: {
    required: true,
    type: "(values: ReadonlySet<any>) => mixed",
    description: "Callback for when a value is selected or deselected"
  }
};
var demoProps = {
  options: [{
    title: "United States",
    value: "us"
  }, {
    title: "Canada",
    value: "ca"
  }, {
    title: "France",
    value: "fr"
  }],
  onCheckedChanged: function onCheckedChanged() {},
  selected: ["us", "fr"]
};

var PillRow = function PillRow(props) {
  var styles = useStylesheet(props);
  var className = props.className,
      style = props.style,
      onCheckedChanged = props.onCheckedChanged,
      selected = props.selected,
      options = props.options,
      pillStyle = props.pillStyle;
  var rootCSS = (0, _styling.css)(styles.root, style, className);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: rootCSS
  }, options.map(function (option) {
    var value = option.value,
        title = option.title;
    var checked = new Set(selected).has(value);
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: title,
      className: (0, _styling.css)(styles.pillContainer)
    }, /*#__PURE__*/_react["default"].createElement(_Pill["default"], {
      style: pillStyle,
      title: title,
      onChange: function onChange(valueChecked) {
        var newSelected = new Set(selected);

        if (valueChecked) {
          newSelected.add(value);
        } else {
          newSelected["delete"](value);
        }

        onCheckedChanged(newSelected);
      },
      selected: checked,
      blueScheme: true
    }));
  }));
};

PillRow.propDoc = propDoc;
PillRow.demoProps = demoProps;

var _default = (0, _mobxReact.observer)(PillRow);

exports["default"] = _default;

var useStylesheet = function useStylesheet(props) {
  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: {
        display: "flex",
        alignItems: "flex-start"
      },
      pillContainer: {
        ":not(:last-child)": {
          marginRight: 10
        }
      }
    });
  }, []);
};